import { render, staticRenderFns } from "./ReturnRefund.vue?vue&type=template&id=2378d268&"
import script from "./ReturnRefund.vue?vue&type=script&lang=js&"
export * from "./ReturnRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports